import React, { useEffect, useRef } from 'react'
import Header from '../components/Practice/Header'
import { useShowDiscontinuationBanner } from '../components/DiscontinuationBanner';
import { Outlet, useLocation, useNavigate, matchPath } from 'react-router-dom';
import { useSelector } from 'react-redux';
import toastr from 'react-hot-toast';

export default function PracticeLayout(props) {
    const location = useLocation();
    const navigate = useNavigate()
    const showBanner = useShowDiscontinuationBanner();
    const prevPathRef = useRef(null);
    const { isAuth, isStaff, staffAllowedPaths } = useSelector(state => state.auth);


    useEffect(() => {
        console.log('prev path...', prevPathRef.current);
        if (isAuth && isStaff && Array.isArray(staffAllowedPaths)) {
            const pathOnly = location.pathname.split('?')[0];
            const hasAccess = staffAllowedPaths.some((allowedPath) =>
                matchPath({ path: allowedPath, end: true }, pathOnly)
            );
            if (!hasAccess) {
                toastr.error('Access denied to this page.');
                if (prevPathRef.current && prevPathRef.current !== location.pathname) {
                    navigate(-1);
                } else {
                    navigate('/practice/dashboard', { replace: true });
                }
            }
            // If access allowed → only then update previous path
            prevPathRef.current = location.pathname + location.search;
        }
    }, [location.pathname]);
    return (
        <>
            <Header />
            {/* with the banner the header is sticky, so it needs no offset */}
            <div className={showBanner ? "" : "mt-5 pt-5"}>
                <Outlet />
            </div>
        </>
    )
}
